import { isEqual } from 'lodash'
import { shallowEqual } from 'react-redux'
import { createSelectorCreator, defaultMemoize } from 'reselect'
import { AppState } from 'src/store'
import { useAppSelector } from 'src/store/hooks'

const createDeepEqualSelector = createSelectorCreator(defaultMemoize, isEqual)

export const userSelector = createDeepEqualSelector(
    (state: AppState) => state.user.data,
    (user) => user
)

export const useUser = () => useAppSelector(userSelector)

export const useUserReferralCode = () =>
    useAppSelector((state) => state.user?.data?.voucherifyReferralCode, shallowEqual)
